module.exports = {"220112001":"云山街道","220112002":"平湖街道","220112003":"奢岭街道","220112004":"山河街道","220112102":"鹿乡镇","220112104":"齐家镇","220112105":"太平镇","220112203":"双营子回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220112.json
// module id = 696
// module chunks = 0